import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, throwError } from 'rxjs';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import * as actions from './actions';
import { MspAjaxService } from 'projects/angular-clarity/src/app/services/ajax/msp-ajax.service';

@Injectable()
export class DattoCredsEffects {
    load$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actions.loadMspDattoCreds),
            mergeMap(() =>
                this.ajax.get('/api/octiga/v3/msp/datto/creds').pipe(
                    map((res) => actions.loadMspDattoCredsSuccess(res)),
                    catchError((error) => of(actions.loadMspDattoCredsFailure({ error }))),
                ),
            ),
        ),
    );

    create$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actions.createMspDattoCreds),
            mergeMap(({ data }) =>
                this.ajax.post<{ valid: boolean }>('/api/octiga/v3/msp/datto/creds', data).pipe(
                    switchMap(({ valid }) =>
                        valid
                            ? this.ajax
                                  .get('/api/octiga/v3/msp/datto/creds')
                                  .pipe(mergeMap((creds) => [actions.createMspDattoCredsSuccess({ data: creds.data })]))
                            : throwError(() => new Error('Invalid credentials')),
                    ),
                    catchError((error) => of(actions.createMspDattoCredsFailure({ error }))),
                ),
            ),
        ),
    );

    put$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actions.putMspDattoCreds),
            mergeMap(({ data }) =>
                this.ajax.put<{ valid: boolean }>('/api/octiga/v3/msp/datto/creds', data).pipe(
                    switchMap(({ valid }) =>
                        valid
                            ? this.ajax
                                  .get('/api/octiga/v3/msp/datto/creds')
                                  .pipe(mergeMap((creds) => [actions.putMspDattoCredsSuccess({ data: creds.data })]))
                            : throwError(() => new Error('Invalid credentials')),
                    ),
                    catchError((error) => of(actions.putMspDattoCredsFailure({ error }))),
                ),
            ),
        ),
    );

    delete$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actions.deleteMspDattoIntegration),
            mergeMap(() =>
                this.ajax.delete('/api/octiga/v3/msp/datto').pipe(
                    map(() => actions.deleteMspDattoIntegrationSuccess()),
                    catchError((error) => of(actions.deleteMspDattoIntegrationFailure({ error }))),
                ),
            ),
        ),
    );

    constructor(
        private actions$: Actions,
        private ajax: MspAjaxService,
    ) {}
}
